import { Component, Input } from '@angular/core';
import { TRANSLATION_POPOVER_SENSITIVLE_FIELD } from '@wdx/shared/utils';

@Component({
    selector: 'wdx-form-field',
    templateUrl: './wdx-form-field.component.html',
    standalone: false,
    host: { class: 'h-100 d-block' },
})
export class WdxFormFieldComponent {
    @Input() locked?: boolean;
    @Input() label? = '';
    @Input() labelForId? = '';
    @Input() legend? = '';
    @Input() guidanceText? = '';
    @Input() isRequired?: boolean;
    @Input() isSensitive?: boolean;
    @Input() validationErrorMessage: null | undefined | string = '';
    @Input() warningMessage: null | undefined | string = '';

    readonly TRANSLATION_POPOVER_SENSITIVLE_FIELD =
        TRANSLATION_POPOVER_SENSITIVLE_FIELD;
}
